import React, { useEffect, useState } from 'react'
import { useFindMenu, useIsMobile, useTrans } from '@next-nx/hooks'
import { CategoriaType, ListingType, PaginaType } from '@next-nx/utils/types'
import {
  Breadcrumbs,
  WContainer,
  MainTitle,
  MainDescription,
  Button,
} from '@next-nx/shared-ui/atoms'
import { OffertaCard, CircleBox, ListIconBoxItem } from '@next-nx/shared-ui/molecules'
import {
  Page,
  HelpBanner,
  ProdottoServiziInclusi,
  VantaggiSection,
} from '@next-nx/shared-ui/organisms'
import styles from './LandingListingTemplate.module.sass'
import { useRouter } from 'next/router'
import { getOffertaUrlParams } from '@next-nx/utils'
import ArrowRight from '../../atoms/Icons/ArrowRight'

interface Props {
  pagina: PaginaType
  categoria: CategoriaType
  filtro_categoria: string
  listing: ListingType
}

const LandingListingTemplate = (props: Props) => {
  const { pagina, categoria, filtro_categoria, listing } = props

  const t = useTrans()
  const router = useRouter()
  const isMobile = useIsMobile()
  const items = listing?.elementi || []

  const landingListingGenericMenu = useFindMenu('pagina-landing-listing')
  const landingListingMenu = useFindMenu(categoria.slug, landingListingGenericMenu)

  const serviziInclusiList = landingListingMenu ? useFindMenu('servizi-inclusi-list', landingListingMenu) : null
  const serviziInclusiList2 = landingListingMenu ? useFindMenu('servizi-inclusi-list-2', landingListingMenu) : null
  const proposteMenu = landingListingMenu ? useFindMenu('proposte', landingListingMenu) : null
  const vantaggiMenu = landingListingMenu ? useFindMenu('vantaggi', landingListingMenu) : null
  const serviziMenu = landingListingMenu ? useFindMenu('servizi', landingListingMenu) : null
  const vantaggiNoleggoMenu = landingListingMenu
    ? useFindMenu('vantaggi-noleggio', landingListingMenu)
    : null

  const helpBannerMenu = useFindMenu('help_banner')
  const helpBannerListingMenu = useFindMenu('listing-pdp', helpBannerMenu)

  return (
    <Page pagina={pagina} item={categoria} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        {!!categoria.nome && <MainTitle label={categoria.nome} className={styles.title} />}
        {!!categoria.descrizione && (
          <MainDescription html={categoria.descrizione} className={styles.description} />
        )}

        {!!serviziInclusiList?.children?.edges.length && categoria.codice === 'tutto-incluso' && (
          <div className={styles.serviziInclusiListContent}>
            <div className={styles.serviziInclusiListTitle}>{serviziInclusiList?.name}</div>
            <div className={styles.serviziInclusiListDescription}>
              {serviziInclusiList?.description}
            </div>
            <div className={styles.serviziInclusiList}>
              {serviziInclusiList.children.edges.map((x) => (
                <ListIconBoxItem item={x?.node} className={styles.listIconBoxItem} />
              ))}
            </div>
            {!!serviziInclusiList2?.children?.edges.length && (
              <div>
                <div className={styles.serviziInclusiListDescription}>
                  {serviziInclusiList2?.description}
                </div>
                <div
                  className={`${styles.serviziInclusiList} ${styles['serviziInclusiList--second']}`}
                >
                  {serviziInclusiList2.children.edges.map((x) => (
                    <ListIconBoxItem item={x?.node} className={styles.listIconBoxItem} />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </WContainer>
      <WContainer>
        {!!vantaggiMenu && (
          <div>
            <ProdottoServiziInclusi item={vantaggiMenu} className={styles.vantaggi} />
          </div>
        )}
        {!!items && items.length > 0 && (
          <div className={styles.listing}>
            <p className={styles.sectionTitle}>{t('In evidenza')}</p>
            {!!(categoria.codice == 'tutto-incluso') && !isMobile && (
              <div className={styles.ctaBox}>
                <Button
                  label={t('Scopri i prodotti')}
                  href={categoria.parent?.url}
                  variant="ghost"
                  icon={<ArrowRight />}
                  iconPos="right"
                />
              </div>
            )}
            <div className={styles.items}>
              {items.map((x) => (
                <OffertaCard
                  key={x.pk}
                  offerta={x}
                  codiceCategoriaPrimaria={filtro_categoria}
                  codiceCategoriaLanding={categoria.codice}
                />
              ))}
            </div>
            {!!(categoria.codice == 'tutto-incluso') && isMobile && (
              <div className={styles.ctaBox}>
                <Button
                  label={t('Scopri i prodotti')}
                  href={categoria.parent?.url}
                  variant="ghost"
                  icon={<ArrowRight />}
                  iconPos="right"
                />
              </div>
            )}
          </div>
        )}
        {proposteMenu && (
          <div className={styles.proposteBox}>
            <CircleBox
              item={{
                ...proposteMenu,
                url: proposteMenu.url + getOffertaUrlParams(proposteMenu.url, filtro_categoria),
              }}
              variant="horizontal"
              className={styles.proposte}
            />
          </div>
        )}
        {!!serviziMenu && categoria.codice !== 'tutto-incluso' && (
          <div>
            <ProdottoServiziInclusi item={serviziMenu} className={styles.serviziInclusi} />
          </div>
        )}
      </WContainer>
      {!!vantaggiNoleggoMenu &&
        vantaggiNoleggoMenu.children &&
        vantaggiNoleggoMenu.children.edges.length > 0 && (
          <div className={styles.vantaggiNoleggio}>
            <VantaggiSection item={vantaggiNoleggoMenu} />
          </div>
        )}

      {helpBannerListingMenu && (
        <HelpBanner item={helpBannerListingMenu} className={styles.helpBanner} />
      )}
    </Page>
  )
}

export default LandingListingTemplate
